import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { clone } from '@jd/jmtd-tools/es/object';
import React from 'react';
import Button from '../../Button';
import ButtonGroup from '../../ButtonGroup';
import ConfigProvider from '../../ConfigProvider';
import DropdownCheckboxOption from '../../DropdownCheckboxOption';
import DropdownRadioOption from '../../DropdownRadioOption';
import Icon from '../../Icon';
import Popover from '../../Popover';
import { RAW, TH_DECORATOR } from '../common';
import SelectOptions from '../../SelectOptions';
import ConfigConsumer from '../../ConfigConsumer';
import { getLocale } from '../../locale';
var FILTER = Symbol('filter');
export default function Filter(_ref) {
  var mapColumns = _ref.mapColumns,
      change = _ref.change,
      cxt = _ref.cxt,
      update = _ref.update;
  var filterContext = cxt[FILTER] = cxt[FILTER] || {}; // filter内部状态

  return {
    columns: mapColumns(function (col, index) {
      var filters = col.filters,
          _col$filteredValue = col.filteredValue,
          filteredValue = _col$filteredValue === void 0 ? null : _col$filteredValue,
          _col$resetFilteredVal = col.resetFilteredValue,
          resetFilteredValue = _col$resetFilteredVal === void 0 ? null : _col$resetFilteredVal,
          _col$filterCancelable = col.filterCancelable,
          filterCancelable = _col$filterCancelable === void 0 ? false : _col$filterCancelable,
          _col$enableFilterEmpt = col.enableFilterEmpty,
          enableFilterEmpty = _col$enableFilterEmpt === void 0 ? false : _col$enableFilterEmpt,
          filterType = col.filterType,
          _col$onFilter = col.onFilter,
          onFilter = _col$onFilter === void 0 ? function () {} : _col$onFilter,
          filterShowSearch = col.filterShowSearch,
          _col$filterDataRender = col.filterDataRender,
          filterDataRender = _col$filterDataRender === void 0 ? function (x) {
        return x;
      } : _col$filterDataRender,
          _col$filterSearchLoad = col.filterSearchLoading,
          filterSearchLoading = _col$filterSearchLoad === void 0 ? false : _col$filterSearchLoad,
          _col$filterSearchValu = col.filterSearchValue,
          filterSearchValue = _col$filterSearchValu === void 0 ? '' : _col$filterSearchValu,
          _col$filterItemRender = col.filterItemRender,
          filterItemRender = _col$filterItemRender === void 0 ? function (item) {
        return item.label;
      } : _col$filterItemRender;
      var main;
      var confirmDisabled = false;

      if (!filters) {
        return null;
      }

      var _filterContext$index = filterContext[index],
          contextValue = _filterContext$index === void 0 ? clone(filteredValue) : _filterContext$index;
      var filterLength = filters.length;
      var renderedData = filterDataRender(filters); // 更新内部值，触发render

      function updateValue(nextValue) {
        filterContext[index] = nextValue;
        update();
      }

      if (filterType === 'checkbox') {
        var curValue = contextValue !== null && contextValue !== void 0 ? contextValue : [];
        var checkedSet = new Set(curValue);
        var checkedLength = curValue.length;
        var allChecked = checkedLength === filterLength;
        confirmDisabled = !enableFilterEmpty && checkedLength === 0;
        main = /*#__PURE__*/React.createElement(React.Fragment, null, filterLength && (filterSearchValue == null || filterSearchValue === '') && /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
          var locale = _ref2.locale;
          return /*#__PURE__*/React.createElement(DropdownCheckboxOption, {
            checked: allChecked,
            indeterminate: !allChecked && checkedLength > 0,
            onChange: function onChange() {
              updateValue(allChecked ? [] : filters.map(function (item) {
                return item.value;
              }));
            }
          }, getLocale(locale).common.selectAll);
        }), renderedData.map(function (item) {
          var value = item.value;
          var checked = checkedSet.has(value);
          return /*#__PURE__*/React.createElement(DropdownCheckboxOption, {
            checked: checked,
            key: value,
            onChange: function onChange() {
              updateValue(checked ? curValue.filter(function (v) {
                return v !== value;
              }) : curValue.concat(value));
            }
          }, filterItemRender(item));
        }));
      } else if (filterType === 'radio') {
        main = renderedData.map(function (_ref3) {
          var label = _ref3.label,
              value = _ref3.value;
          var checked = value === contextValue;
          return /*#__PURE__*/React.createElement(DropdownRadioOption, {
            checked: checked,
            key: value,
            onChange: function onChange() {
              if (!checked) {
                updateValue(value);
              } else if (filterCancelable) {
                updateValue(null);
              }
            }
          }, label);
        });
      } else {
        return null;
      } // 触发change事件


      function triggerChange(nextValue) {
        // 减少重复触发
        if (JSON.stringify(nextValue) === JSON.stringify(filteredValue)) {
          return;
        }

        onFilter(nextValue);
        change('filter', {
          column: col[RAW],
          filteredValue: nextValue
        });
      }

      return _defineProperty({}, TH_DECORATOR, function (children) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(ConfigProvider, {
          size: "small"
        }, /*#__PURE__*/React.createElement(Popover, {
          arrowPointAtCenter: true,
          className: "jmtd-table-plugin-dropdown-popover",
          placement: "bottomLeft",
          trigger: "click",
          onClose: function onClose() {
            // 弹框关闭时清空内部值
            delete filterContext[index];
            update();
          },
          popover: function popover(_ref4) {
            var setOpen = _ref4.setOpen;
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectOptions, {
              showSearch: filterShowSearch,
              searchValue: filterSearchValue,
              searchLoading: filterSearchLoading,
              empty: !(renderedData !== null && renderedData !== void 0 && renderedData.length),
              onSearch: function onSearch(v) {
                change('filterSearch', {
                  column: col[RAW],
                  value: v
                });
              }
            }, /*#__PURE__*/React.createElement("div", {
              className: "jmtd-table-plugin-filters-option-list"
            }, main)), /*#__PURE__*/React.createElement(ButtonGroup, {
              className: "jmtd-table-plugin-filters-buttons",
              block: true
            }, /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref5) {
              var locale = _ref5.locale;
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                link: true,
                onClick: function onClick() {
                  updateValue(resetFilteredValue);
                }
              }, getLocale(locale).common.reset), /*#__PURE__*/React.createElement(Button, {
                link: true,
                semantic: "primary",
                disabled: confirmDisabled,
                onClick: function onClick() {
                  setOpen(false);
                  triggerChange(contextValue);
                }
              }, getLocale(locale).common.confirm));
            })));
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-plugin-filter"
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "jmti-filter jmtd-table-plugin-filter-icon"
        }), /*#__PURE__*/React.createElement("div", {
          className: "jmtd-table-head-placeholder"
        })))));
      });
    })
  };
}